import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SplitTimeComponent } from './split-time.component';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';

@NgModule({
    declarations: [SplitTimeComponent],
    imports: [CommonModule, FormsModule, NzInputModule, NzPopoverModule, NzSelectModule],
    exports: [SplitTimeComponent],
})
export class SplitTimeModule {}
